import React, { Suspense, useState,useEffect } from 'react';
import { Route, Routes, useLocation, useNavigate,Navigate } from 'react-router-dom';
import {
  MenuFoldOutlined,
  MenuUnfoldOutlined,
  SettingOutlined,
  LogoutOutlined,
  DownOutlined,
  RightOutlined,
  UsergroupAddOutlined
} from '@ant-design/icons';
import {
  FaCalendarAlt,
  FaRegFileAlt,
  FaChartBar,
  FaReceipt,
} from 'react-icons/fa';

import { ConfigProvider, Layout, Menu, Button } from 'antd';
import 'antd/dist/reset.css';
import ActualSalesPage from '../pages/actualsales';
import SalesLapPage from '../pages/saleslap';
import ForecastingVsBudgetPage from '../pages/Forecasting';
import SettingsPage from '../pages/Settings';
import SalesSummaryYearlyPage from '../pages/SalesSummaryYearly';
import SalesSummaryMonthlyPage from '../pages/SalesSummaryMonthly';
import BulkUploadHistory from './forecastbulkuploadhistory';
import BulkUploadForecast from './bulkuploadforecast';
import { ToastContainer } from 'react-toastify';
import BulkUploadSaleslap from './bulkuploadsaleslap';
import SubMenu from 'antd/es/menu/SubMenu';
import ReasonCRUD from './ReasonManager';
import Users from '../pages/Users';
import AddUser from '../pages/AddUser';
import SalesBulkUploadHistory from './salesbulkuploadhistory';
import ViewSalesUploadHistory from './viewsalesuploadhistory';
import ViewForecastHistory from './viewforecastuploadhistory';
import BulkUpload from './bulkupload';
import BulkUploadActual from './bulkuploadactuals';
import ViewActualBulkUploadHistory from './viewactualuploadhistory';
import ActualSaleBulkUploadHistoryDetails from './ActualSaleBulkUploadHistoryDetails';
import {jwtDecode} from 'jwt-decode';
import ConfirmDeleteModal from './common/ConfirmDeleteModal';
import SalesSummaryPage from '../pages/SalesSummaryPage';
import ForecastDetails from '../pages/ForecastDetails';
import ActualSalesSummaryPage from '../pages/ActualSalesSummary';
import ActualSalesSummaryPageNew from '../pages/ActualSalesSummaryNew';
import NewForecastingVsBudgetPage from '../pages/ForecastingNew';
  import ForecastDetailsNew from '../pages/ForecastDetailsNew';
import SalesTotalPage from '../pages/SalesTotal';
import BulkUploadSalesTotal from './BulkUploadSalesTotal';
import SalesLapNew from './saleslapnew';
const { Header, Sider, Content } = Layout;
const Spinner = React.lazy(() => import('./spinner'));

const LayoutPage = () => {
  const [collapsed, setCollapsed] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const [loggedUser, setLoggedUserData] = useState({});
  const [showModal, setShowModal] = useState(false);

  const Title = location.pathname
  .replace('/', '') // Remove the first slash
  .replace('/', ' - ') // Replace the second slash with a hyphen
  .replace('-', ' ') // Replace the hyphen with a space
  .split(' ') // Split the string by space
  .slice(0, 2) // Take only the first two words ("Edit" and "User")
  .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()) // Capitalize the first letter of each word
  .join(' '); // Join them back together into a single string

console.log(Title); // Output: Edit User


  // Toggle the sidebar collapsed state
  const toggleCollapsed = () => {
    console.log("collapsed",collapsed);
    setCollapsed(!collapsed);
  };

  const handleMenuClick = (e) => {
    if (e.key === '/login') {
      setShowModal(true);
      // localStorage.removeItem('authToken'); // Clear the token from localStorage
      // navigate('/login'); // Redirect to the login page    } else {
    } else {
      navigate(e.key);
    }
  };
  const logOut = () => {
    localStorage.removeItem('authToken'); // Clear the token from localStorage
    navigate('/login'); // Redirect to the login page 
  };
  useEffect(() => {
    const token = localStorage.getItem("authToken"); // Get the token from localStorage
    if (token) {
      try {
        const decodedToken = jwtDecode(token); // Decode the token
        setLoggedUserData(decodedToken); // Set the decoded token data to state
      } catch (error) {
        console.error("Error decoding token:", error);
        setLoggedUserData(null); // Clear loggedUser if decoding fails
      }
    } else {
      setLoggedUserData(null); // Clear loggedUser if no token is found
    }
  }, []);
  // Define menu items
  // const menuItems = [
  //   {
  //     key: '/actual-sales',
  //     icon: <FaChartBar />,
  //     label: 'Actual Sales',
  //   },
  //   {
  //     key: '/forecasting',
  //     icon: <FaReceipt />,
  //     label: 'Forecasting vs Budget',
  //   },
  //   {
  //     key: '/saleslap',
  //     icon: <FaCalendarAlt />,
  //     label: 'Saleslap',
  //   },
  //   {
  //     key: '/sales-summary',
  //     icon: <FaRegFileAlt />,
  //     label: 'Sales Summary',
  //     children: [
  //       {
  //         key: '/sales-summary/yearly',
  //         label: 'Yearly',
  //       },
  //       {
  //         key: '/sales-summary/monthly',
  //         label: 'Monthly',
  //       },
  //     ],
  //   },
  // ];
  const menuItems = [
    {
      key: '/actual-sales',
      icon: <FaChartBar />,
      label: 'Actual Sales',
    },
    {
      key: '/actual-sale-summary',
      icon: <FaChartBar />,
      label: 'Actual Sales Summary',
    },
    {
      key: '/forecasting',
      icon: <FaReceipt />,
      label: 'Forecasting vs Budget',
    },
    {
      key: '/saleslap',
      icon: <FaCalendarAlt />,
      label: 'Saleslap',
    },
    {
      key: '/sales-total',
      icon: <FaChartBar />,
      label: 'Sales Total',
    },
    {
      key: '/sales-summary',
      icon: <FaRegFileAlt />,
      children: [
        {
          key: '/sales-summary/yearly',
          label: 'Yearly',
        },
        {
          key: '/sales-summary/monthly',
          label: 'Monthly',
        },
      ],
    },
    {
      key: '/settings',
      icon: <SettingOutlined />,
      label: 'Settings',
    },
    {
      key: '/users',
      icon: <UsergroupAddOutlined />,
      label: 'Users',
    },
    {
      key: '/login',
      icon: <LogoutOutlined />,
      label: 'Logout',
      onClick: handleMenuClick, // Call the logout handler
    },
  ];

  return (
    <Layout style={{ minHeight: '100vh', background: '#fff' }}>
      {/* Sidebar */}
      <ConfigProvider
        theme={{
          token: {},
          components: {
            Menu: {
              itemSelectedBg: '#fff',
              itemSelectedColor: '#E61E1E',
              itemHoverBg: '#f0f0f0',
              itemHoverColor: '#E61E1E',
              colorBorder: '#E6E6E6',
              itemPaddingInline: 5,
              subMenuItemSelectedColor: '#E61E1E',
            },
          },
        }}
      >
        <Sider
          trigger={null}
          collapsible
          collapsed={collapsed}
          // breakpoint="lg"
          width={220}
          style={{
            background: '#fff',
            height: '100vh',
          }}
        >
          <div className="flex items-center justify-between px-2 py-4 border-b border-gray-200">
            <div className="text-xl font-bold text-red-600">TOSHIBA</div>
            <Button
              type="text"
              icon={collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
              onClick={toggleCollapsed}
              className="text-gray-600"
            />
          </div>

          {/* <Menu
            mode="inline"
            selectedKeys={[location.pathname]}
            defaultSelectedKeys={['/actual-sales']}
            style={{ borderInlineEnd: 0, background: '', color: '#E61E1E', padding: '0' }}
            onClick={handleMenuClick}
            items={menuItems} // Use the items prop
          /> */}

          <Menu
            mode="inline"
            selectedKeys={[location.pathname]}
            defaultSelectedKeys={['/actual-sales']}
            style={{
              borderInlineEnd: 0,
              background: '',
              color: '#E61E1E',
              padding: '0',
              borderBottom: '1px solid #C8C8C8', // Border for the main Menu
            }}
            onClick={handleMenuClick}
          >
            {/* <SubMenu
              key="/actualsales"
              
              expandIcon={({ isOpen }) =>
                isOpen ? (
                  <DownOutlined style={{ fontSize: '16px', color: '#000' }} />
                ) : (
                  <RightOutlined style={{ fontSize: '16px', color: '#000' }} />
                )
              }
              icon={<FaChartBar />}
              style={{
                paddingLeft: '0px',
                borderRadius: "0",
              }}
              title={
                <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%', padding: "0px" }}>
                  <span>ActualSales</span>
                </div>
              }
            >
                <Menu.Item
                  key="/actual-sales"
                  
                  style={{
                    borderBottom: "1px solid #C8C8C8",
                    borderRadius: "0",
                    
                  }}
                >
                  <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%', padding: "0px" }}>
                    <span>Actual Sales</span>
                    <RightOutlined />
                  </div>
                </Menu.Item>
                 <Menu.Item
              key="/actual-sales-summary"
              
              style={{
                borderBottom: "1px solid #C8C8C8",
                borderRadius: "0",
                
              }}
            >
              <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%', padding: "0px" }}>
                <span>Actual Sales Summary</span>
                <RightOutlined />
              </div>
                </Menu.Item>
              </SubMenu> */}
           
             <SubMenu
              key="/actualisales"
              expandIcon={({ isOpen }) =>
                isOpen ? (
                  <DownOutlined style={{ fontSize: '16px', color: '#000' }} />
                ) : (
                  <RightOutlined style={{ fontSize: '16px', color: '#000' }} />
                )
              }
              icon={<FaChartBar />}
              style={{
                paddingLeft: '0px',
                borderRadius: "0",
              }}
              title={
                <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%', padding: "0px" }}>
                  <span>ActualSales</span>
                </div>
              }
              // onTitleClick={() => navigate("/actual-sales")} // 👈 navigate on click
            >
              <Menu.Item
                key="/actual-sales"
                style={{
                  // borderBottom: "1px solid #C8C8C8", // Border for Yearly
                  borderRadius: "0",
                  paddingLeft: '35px',
                }}
              >
                <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%', paddingLeft: "20px" }}>
                  <span>Sales Details</span>
                  <RightOutlined />
                </div>
              </Menu.Item>
              <Menu.Item
                key="/actual-sales-summary"
                style={{
                  // borderBottom: "1px solid #C8C8C8", // Border for Yearly
                  borderRadius: "0",
                  paddingLeft: '35px',
                }}
              >
                <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%', paddingLeft: "20px" }}>
                  <span>Sales Summary</span>
                  <RightOutlined />
                </div>
              </Menu.Item>
              <Menu.Item
                key="/sbu-summary"
                style={{
                  // borderBottom: "1px solid #C8C8C8", // Border for Yearly
                  borderRadius: "0",
                  paddingLeft: '35px',
                }}
              >
                <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%', paddingLeft: "20px" }}>
                  <span>SBU Summary </span>
                  <RightOutlined />
                </div>
              </Menu.Item>
                {/* <Menu.Item
                key="/forecast-details"
                style={{
                  // borderBottom: "1px solid #C8C8C8", // Border for Yearly
                  borderRadius: "0",
                  paddingLeft: '35px',
                }}
              >
                <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%', paddingLeft: "20px" }}>
                  <span>Forecast Details</span>
                  <RightOutlined />
                </div>
              </Menu.Item> */}
               </SubMenu>
               <SubMenu
              key="/forcastvsbudget"
              expandIcon={({ isOpen }) =>
                isOpen ? (
                  <DownOutlined style={{ fontSize: '16px', color: '#000' }} />
                ) : (
                  <RightOutlined style={{ fontSize: '16px', color: '#000' }} />
                )
              }
              icon={<FaReceipt />}
              style={{
                paddingLeft: '0px',
                borderRadius: "0",
              }}
              title={
                <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%', padding: "0px" }}>
                  <span>Forecasting vs Budget</span>
                </div>
              }
            >
              <Menu.Item
                key="/forecasting"
                style={{
                  // borderBottom: "1px solid #C8C8C8", // Border for Yearly
                  borderRadius: "0",
                  paddingLeft: '35px',
                }}
              >
                <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%', paddingLeft: "20px" }}>
                  <span>Forecast Summary</span>
                  <RightOutlined />
                </div>
              </Menu.Item>
               <Menu.Item
                key="/forecasting-new"
                style={{
                  // borderBottom: "1px solid #C8C8C8", // Border for Yearly
                  borderRadius: "0",
                  paddingLeft: '35px',
                }}
              >
                <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%', paddingLeft: "20px" }}>
                  <span>Table</span>
                  <RightOutlined />
                </div>
              </Menu.Item>
                <Menu.Item
                key="/forecast-details"
                style={{
                  // borderBottom: "1px solid #C8C8C8", // Border for Yearly
                  borderRadius: "0",
                  paddingLeft: '35px',
                }}
              >
                <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%', paddingLeft: "20px" }}>
                  <span>Forecast Details</span>
                  <RightOutlined />
                </div>
              </Menu.Item>
               <Menu.Item
                key="/forecast-details-new"
                style={{
                  // borderBottom: "1px solid #C8C8C8", // Border for Yearly
                  borderRadius: "0",
                  paddingLeft: '35px',
                }}
              >
                <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%', paddingLeft: "20px" }}>
                  <span>Sales Summary</span>
                  <RightOutlined />
                </div>
              </Menu.Item>
               </SubMenu>
            {/* Saleslap Menu Item */}
            <Menu.Item
              key="/saleslap"
              icon={<FaCalendarAlt />}
              style={{
                borderBottom: "1px solid #C8C8C8",
                borderRadius: "0",
                paddingLeft: "15px",
              }}
            >
              <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                <span>Saleslap</span>
                <RightOutlined />
              </div>
            </Menu.Item>
              <Menu.Item
              key="/saleslap-new"
              icon={<FaCalendarAlt />}
              style={{
                borderBottom: "1px solid #C8C8C8",
                borderRadius: "0",
                paddingLeft: "15px",
              }}
            >
              <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                <span>SaleslapNew</span>
                <RightOutlined />
              </div>
            </Menu.Item>
            <Menu.Item
              key="/sales-total"
              icon={<FaChartBar />}
              style={{
                borderBottom: "1px solid #C8C8C8",
                borderRadius: "0",
                paddingLeft: "15px",
              }}
            >
              <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                <span>Sales Total</span>
                <RightOutlined />
              </div>
            </Menu.Item>
            <Menu.Item
              key="/sales-summary"
              icon={<FaRegFileAlt />}
              style={{
                borderBottom: "1px solid #C8C8C8",
                borderRadius: "0",
                paddingLeft: "15px",
              }}
            >
              <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                <span>Sales Summary</span>
                <RightOutlined />
              </div>
            </Menu.Item>
            {/* <SubMenu
              key="/sales-summary"
              expandIcon={({ isOpen }) =>
                isOpen ? (
                  <DownOutlined style={{ fontSize: '16px', color: '#000' }} />
                ) : (
                  <RightOutlined style={{ fontSize: '16px', color: '#000' }} />
                )
              }
              icon={<FaRegFileAlt />}
              style={{
                paddingLeft: '0px',
                borderRadius: "0",
                borderBottom: "1px solid #C8C8C8",
              }}
              title={
                <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%', padding: "0px" }}>
                  <span>Sales Summary</span>
                </div>
              }
            >
              
              <Menu.Item
                key="/sales-summary/yearly"
                style={{
                  borderBottom: "1px solid #C8C8C8", // Border for Yearly
                  borderRadius: "0",
                  paddingLeft: '35px',
                }}
              >
                <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%', paddingLeft: "20px" }}>
                  <span>Yearly</span>
                  <RightOutlined />
                </div>
              </Menu.Item>

              <Menu.Item
                key="/sales-summary/monthly"
                style={{
                  borderRadius: "0",
                  paddingLeft: '35px',
                }}
              >
                <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%', paddingLeft: "20px" }}>
                  <span>Monthly</span>
                  <RightOutlined />
                </div>
              </Menu.Item>
            </SubMenu> */}
            { loggedUser && loggedUser.role_name == "admin" && (
              <>
            <Menu.Item
              key="/users"
              icon={<UsergroupAddOutlined />}
              style={{
                borderBottom: "1px solid #C8C8C8", // Border for Yearly
                borderRadius: "0",
                paddingLeft: '35px',
              }}
            >
             
                <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                <span> Users</span>
                <RightOutlined />
              </div>
           
              
            </Menu.Item>
            
            <SubMenu
              key="/masters"
              expandIcon={({ isOpen }) =>
                isOpen ? (
                  <DownOutlined style={{ fontSize: '16px', color: '#000' }} />
                ) : (
                  <RightOutlined style={{ fontSize: '16px', color: '#000' }} />
                )
              }
              icon={<FaRegFileAlt />}
              style={{
                paddingLeft: '0px',
                borderRadius: "0",
              }}
              title={
                <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%', padding: "0px" }}>
                  <span>Masters</span>
                </div>
              }
            >
              <Menu.Item
                key="/reasons"
                style={{
                  // borderBottom: "1px solid #C8C8C8", // Border for Yearly
                  borderRadius: "0",
                  paddingLeft: '35px',
                }}
              >
                <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%', paddingLeft: "20px" }}>
                  <span>GPS Reasons</span>
                  <RightOutlined />
                </div>
              </Menu.Item>

            </SubMenu>
            </>
            ) }
          </Menu>


          <div style={{ position: 'absolute', bottom: 0, width: '100%' }}>
            <Menu
              mode="inline"
              selectedKeys={[location.pathname]}
              style={{
                position: 'absolute',
                bottom: 0,
                width: '100%',
                paddingBottom: 10,
              }}
              onClick={handleMenuClick}
            >
              <Menu.Item key="/settings" icon={<SettingOutlined />} style={{ borderBottom: "1px solid #C8C8C8", borderRadius: "0" }} >
                Settings
              </Menu.Item>
              <Menu.Item key="/login" icon={<LogoutOutlined />} style={{ borderBottom: "1px solid #C8C8C8", borderRadius: "0" }} >
                Logout
              </Menu.Item>
            </Menu>
          </div>
        </Sider>
      </ConfigProvider>

      {/* Main layout */}
      <Layout className="site-layout">
        {/* Header */}
        <Header
          className="bg-white flex items-center justify-between px-4"
          style={{ borderBottom: '1px solid #ddd', background: '#fff' }}
        >
          <div className="text-xl font-semibold text-[#1D1D1D]">{Title}</div>
          <div className="flex items-center gap-4">
            <span className="text-gray-800 font-medium capitalize">{loggedUser.name}</span>
            <img
              src="/images/profile.png"
              alt="Profile"
              className="w-8 h-8 rounded-full"
            />
          </div>
        </Header>

        {/* Content */}
        <Content
          className="p-4 bg-[#f9fafb]"
          style={{ overflowY: 'auto', height: 'calc(100vh - 64px)' }} // Make content scrollable
        >
          <ToastContainer />
          <Suspense fallback={Spinner}>
            <Routes>
              <Route path="/saleslap" element={<SalesLapPage />} />
                <Route path="/saleslap-new" element={<SalesLapNew />} />
              <Route path="/sales-total" element={<SalesTotalPage />} />
              <Route path="/upload-sales-total" element={<BulkUploadSalesTotal />} />
              <Route path="/actual-sales" element={<ActualSalesPage closeSidebar={() => setCollapsed(true)}  />} />
               <Route path="/actual-sales-summary" element={<ActualSalesSummaryPage />} />
               <Route path="/sbu-summary" element={<ActualSalesSummaryPageNew />} />

              <Route path="/forecasting" element={<ForecastingVsBudgetPage />} />
              <Route path="/forecasting-new" element={<NewForecastingVsBudgetPage />} />
              <Route path="/forecast-details" element={<ForecastDetails />} />
              <Route path="/forecast-details-new" element={<ForecastDetailsNew />} />
              <Route path="/settings" element={<SettingsPage />} />
              <Route path="/sales-summary/monthly" element={<SalesSummaryMonthlyPage />} />
              <Route path='/sales-summary/yearly' element={<SalesSummaryYearlyPage />} />
              <Route path='/upload-actual-excel' element={<BulkUploadActual />} />
              <Route path='/actuals-bulk-upload-history' element={<ViewActualBulkUploadHistory />} />
              <Route path='/upload-forecast-excel' element={<BulkUploadForecast />} />
              <Route path='/upload-saleslap-excel' element={<BulkUploadSaleslap />} />
              <Route path='/bulk-upload-history' element={<BulkUploadHistory />} />
              <Route path='/bulk-upload-error/:id' element={<ViewForecastHistory />} />
              <Route path='/sales-bulk-upload-history' element={<SalesBulkUploadHistory />} />
              <Route path='/sales-bulk-upload-error/:id' element={<ViewSalesUploadHistory />} />.
              <Route path="/bulk-upload-history-details/:id" element={<ActualSaleBulkUploadHistoryDetails />} />
              <Route path='/reasons' element={<ReasonCRUD />} />
              <Route path="/sales-summary" element={<SalesSummaryPage />} />

              {loggedUser && loggedUser.role_name === "admin" && (
                  <>
                    <Route path="/users" element={<Users />} />
                    <Route path="/add-user" element={<AddUser />} />
                    <Route path="/edit-user/:id" element={<AddUser />} />
                  </>
                )}
                    <Route path="*" element={<Navigate to="/actual-sales" replace />} />

            </Routes>
          </Suspense>
        </Content>
      </Layout>
      <ConfirmDeleteModal
                    show={showModal}
                    
                    onCancel={() => setShowModal(false)}
                    onConfirm={logOut}
                    title ="Logout"
                    message={`Are you sure you want to logout ?`}
                  />

    </Layout>
  );
};

export default LayoutPage;
